/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import { alpha_spaces } from 'vee-validate/dist/rules';

extend('alpha-spaces', {
    ...alpha_spaces,
    message: 'Only letters and numbers are accepted'
});
